import styled, {css} from 'styled-components';
import IconCheck from './../../assets/images/iconCheckPremium.png'
interface ItemProps {
  readonly color?: string;
  readonly size?: string;
  readonly margin?: string;
}
export const LabelsContainer = styled.div`
  box-sizing: border-box;
  height: 41px;
  width: 315px;
  position: relative;
  align-self: flex-end;

  display: flex;
  justify-content: space-evenly;
  align-items: center;

  border-radius: 7px;
  border: 1.2px solid rgba(240, 240, 240, 1);
`;
export const LabelsWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: 17px;
`;

export const Oval = styled.div<ItemProps>`
  border-radius: 50% 50% 50% 50%;
  display: inline-block;
  margin-left: auto;

  ${props => {
    const height = 'min-height:' + props.size + 'px;height:' + props.size + 'px;';
    const width = 'min-width:' + props.size + 'px;width:' + props.size + 'px;';
    const margin = 'margin:' + props.margin + ';';
    let color;
    switch (props.color) {
      case 'yellow':
        color = 'rgba(255,191,86,1)';
        break;
      case 'red':
        color = 'rgba(228,146,255,1)';
        break;
      case 'blue':
        color = 'rgba(0,155,158,1)';
        break;
      case 'green':
        color = 'rgba(149,221,101,1)';
        break;
      default:
        color = 'rgba(81, 227, 99, 1)';
        break;
    }
    const background = 'background:' + color + ';';
    return css`
        ${height}
        ${width}
        ${background}
        ${margin}
    `;
  }};
`;
export const TextContainer = styled.div`
  color: rgba(93, 110, 129, 1);
  font-family: 'Proxima Nova';
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.61px;
  line-height: 12px;
  height: 12px;

  min-width: max-content;
  align-self: center;
`;
export const AlertContainer = styled.div`
  color: rgba(93, 110, 129, 1);
  font-family: 'Proxima Nova';
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.55px;
  line-height: 9px;
  align-items: center;
`;

export const UlPremiumUpgrade = styled.ul`
  font-size: 14px;
  padding: 0;
  list-style: none;
`;

export const LiItemsPremiumUpgrade = styled.li`
  display: flex;
  align-items: center;
  font-weight: 500;
  line-height: 12px;
  margin-bottom: 8px;
  &::before {
    content: url("${IconCheck}");
    margin-right: 10px;
    font-size: 14px;
    margin-top: 2px;
  }
`;

export const ButtonPremiumUpgradeLogOut = styled.button`
  border-radius: 10px;
  background-color: red;
  color: white;
  padding: 12px 34px;
  cursor: pointer;
  border: none;
  width: fit-content;
  font-weight: 700;
  min-height: 48px;
  line-height: 24px;
`

